export default {
	project_name: 'TCL Experts',
	point: 'Star | Stars',
	points: 'Stars',
	point_plural: 'Stars',
	score: 'Stars',
	points_earned: 'Stars Ganhos',
	my_points: 'Minhas Stars',
	points_table: 'Tabela de Stars',
	acc_score: 'Star acumulado | Stars acumulados',
	company_agency: 'Eu sou',
	headquarter: 'Rede e Loja',
	find_your_network: 'Encontre sua rede',
	document: 'CPF',
}
